import { render, staticRenderFns } from "./NotificationManagement.vue?vue&type=template&id=2aed24d4&"
import script from "./NotificationManagement.vue?vue&type=script&lang=js&"
export * from "./NotificationManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports